var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-brand-secondary",attrs:{"id":"BupaSso"}},[_c('div',{staticClass:"d-flex flex-row align-items-center justify-content-center mx-auto container m-5"},[(!_vm.errorMessage)?_c('Loader'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }